import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchUserAction } from '../store/user';

class AuthCallbackView extends Component {
  componentDidMount() {
    this.fetchUser();
  }

  fetchUser = async () => {
    const user = await this.props.fetchUserAction();
    if (user) {
      this.props.history.push('/profile/');
    } else {
      this.props.history.push('/?error=Authentication failed');
    }
  };

  render() {
    return (
      <div className="container-fluid my-4">
        <div className="row">
          <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
            <div className="card">
              <div className="card-body p-5 text-center">
                <h4 className="card-title">Authenticatie...</h4>
                <p>Even geduld, u wordt ingelogd.</p>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchUserAction: () => dispatch(fetchUserAction())
});

export default withRouter(connect(null, mapDispatchToProps)(AuthCallbackView));
